module.exports = __webpack_public_path__ + "static/img/Fi9jiangche.edd8a9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Fi9jiangche.jpg
// module id = +tw7
// module chunks = 1